import { useState, useRef } from 'react';
import { Play, Pause } from 'lucide-react';
import './VideoSection.css';

function VideoSection() {
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const videoRef = useRef(null);

    const handlePlayPause = () => {
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleTimeUpdate = () => {
        if (videoRef.current) {
            const p = (videoRef.current.currentTime / videoRef.current.duration) * 100;
            setProgress(p);
        }
    };

    const handleSliderChange = (e) => {
        const newValue = Number(e.target.value);
        setProgress(newValue);
        if (videoRef.current) {
            videoRef.current.currentTime = (newValue / 100) * videoRef.current.duration;
        }
    };

    return (
        <div className="video-container">
            <h2 className="video-title">
                Découvrez notre solution en action
            </h2>
            <p className="video-description">
                Regardez cette vidéo pour voir comment notre produit peut transformer votre quotidien. Simple, efficace et innovant.
            </p>

            <div className="video-wrapper">
                <video
                    className="video-player"
                    ref={videoRef}
                    src="/video/voiceDubbing.mp4"
                    onClick={handlePlayPause}
                    onTimeUpdate={handleTimeUpdate}
                    loop
                />

                <button className="play-pause-button" onClick={handlePlayPause}>
                    {isPlaying ? <Pause size={28} /> : <Play size={28} />}
                </button>

                <div className="video-overlay">
                    <div className="video-timeline">
                        <div className="timeline-track">
                            <div className="timeline-fill" style={{ width: `${progress}%` }} />
                            <input
                                type="range"
                                className="timeline-input"
                                min={0}
                                max={100}
                                step={0.1}
                                value={progress}
                                onChange={handleSliderChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoSection;
